export default __webpack_public_path__ + "static/media/element_91.3a2f4efa.webp";